import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: true };

const reDirectSlice = createSlice({
  name: "Redirect",
  initialState,
  reducers: {
    empWise(state) {
      state.value = false;
    },
    meetingReport(state) {
      state.value = true;
    },
  },
});

export const { empWise, meetingReport } = reDirectSlice.actions;
export default reDirectSlice.reducer;
